<script>
import communicator from '@/mixins/admin/communicator';

export default {
  mixins: [communicator],
  mounted() {
    // console.log('Communicator.mounted');
  },
  template: '<div></div>',
};
</script>
